<template>
    <div >
        <waiting :open="openModalWaiting"/>
        
        <navbar-tournoi
            :club="club"
            :tournoi="tournoi"
            :parties="parties"
            :role="role"
            :indexPartie="indexPartie"
            display="inprogress"
            :joueurs="joueurs"
            @reinitialiser="reinitialiser"
            @nav="setNav"
            @back="$emit('back')"
            @setState="setState"
            @activeBuger="menuBurger = !menuBurger"
            title=""
        />
        
                    <vue-html2pdf
                        :show-layout="false"
                        :float-layout="true"
                        :enable-download="true"
                        :preview-modal="true"
                        :paginate-elements-by-height="200"
                        filename="hee hee"
                        :pdf-quality="2"
                        :manual-pagination="true"
                        pdf-format="a4"
                        pdf-orientation="landscape"
                        pdf-content-width="1100px"
                        :html-to-pdf-options="options"
                        ref="html2PdfPartie"
                        v-if="equipesPagination.length!=0"
                    >
                        <pdf-partie 
                            v-if="equipesPagination.length!=0" 
                            :tournoi="tournoi" slot="pdf-content" 
                            :club="club" 
                            :equipesPagination="equipesPagination" 
                            :title="'Partie ' + (indexPartie+1)"
                            />
                    </vue-html2pdf>
        <div class="g_menuMobile"  v-show="!openModal">
            <table class="g_menuFooterMin">
                <tr>
                    <td colspan="3" class="g_headerFooter" v-if="partie">
                        {{titlePartie()}}  :
                        <span v-show="partie.state=='WAITING'">
                            En attente
                        </span>
                        <span  v-show="partie.state=='INPROGRESS'" v-if="equipes!=null">
                            En cours {{nbParties}} / {{equipes.length}}
                        </span>
                        <span v-show="partie.state=='FINISH'">
                            Terminé
                        </span>
                    </td>
                    <td colspan="2" style="position: relative" >
                        <div v-show="inJoueurInTournoi==1" style="position:absolute;top:-40px;right: 5px;">
                        <s-button theme="is-small is-info" icon="gamepad" label="Ma partie"
                            :disabled="isOffline"
                            @onclick="goMonTournoi"
                        />
                        </div>
                         <s-you-tube id="video_deroulement" :club="club" theme="is-info is-small" />
                    </td>
                </tr>
                <tr>
                    
                    <td v-show="searchByMobile">
                        <s-button icon="undo" theme="is-warning" label="Annuler" @onclick="searchByMobile=false" mode="V"/>
                        
                    </td>
                    <td v-show="!searchByMobile">
                        <s-button icon="search" theme="is-light" label="Rechercher" @onclick="searchByMobile=true"
                            mode="V"/>
                    </td>
                    <td colspan="4" v-show="searchByMobile" style="text-align:left;width:90%;vertical-align:top;padding-right:10px;">
                        <s-input-search 
                                theme="is-info" 
                                themeEraser="is-warning"
                                v-model="search" 
                                width="80%" 
                                placeholder="numéro ou nom"/>
                    </td> 
                    <td  v-if="partie" v-show="(role=='owner' | role=='admin') && !searchByMobile">
                        <s-button icon="cog" theme="is-dark" label="Paramètres" 
                            @onclick="modalConfiguePartie=true"
                            :role="role" 
                            mode="V"
                        />
                        
                    </td>
                   
                    <td v-show="!searchByMobile">
                        <s-button icon="users" @onclick="setNav('list')" label="Joueurs" theme="is-light" mode="V"/>                        
                    </td>
                     <td v-show="!searchByMobile">
                        <s-button icon="list" @onclick="openChangeIndexPartie=true" label="Changer" theme="is-light" mode="V"/>
                        
                    </td>
                    <td v-if="partie" v-show="!searchByMobile">
                        
                        <s-button  :role="role"  
                        v-show="partie.state=='WAITING' && indexPartie < parties.length" 
                        icon="play" label="Démarrer" theme="is-success" @onclick="setStatePartie"
                        mode="V"/>

                        <s-button  
                            :role="role"  v-show="partie.state=='INPROGRESS'  && indexPartie < parties.length" 
                            icon="pause" label="En attente" theme="is-primary" @onclick="setStatePartie"
                            mode="V"
                        />
                         <s-button  :role="role"  
                            v-if="!displayOrganiser"
                            v-show="partie.state=='FINISH'" 
                            icon="arrow-right" label="Suivant" 
                            id="next" theme="is-info" @onclick="changeIndexPartie(indexPartie+1)"
                            mode="V"/>
                        <s-button  
                            :role="role"   icon="play" 
                            label="Continuer" theme="is-info" 
                            @onclick="modalOrganiserTournoi=true"
                            v-show="displayOrganiser"
                            mode="V"
                        />
                        
                    </td>
                </tr>
               
            </table>
        </div>
       
        <div class="topFixed" >  
            <div style="float:right" v-if="parties">
                    
                    <div style="text-align:right;padding-top: 10px;">
                        
                        <s-button id="prec" icon="arrow-left" @onclick="changeIndexPartie(indexPartie-1)" label="" theme="is-primary" 
                            :disabled="indexPartie==0" />&nbsp;
                        <s-button id="next" icon="arrow-right" @onclick="changeIndexPartie(indexPartie+1)" label="" theme="is-primary"
                            :disabled="disabledPartieNext(indexPartie)" />&nbsp;
                        <s-button icon="list"  @onclick="openChangeIndexPartie=true" label="" theme="is-primary"/>&nbsp;
                        &nbsp; <s-button icon="file-pdf" theme="is-info is-normal" label="Exporter en pdf" @onclick="generateReport()"/>
                     
                        
                        <div v-show="!changeFlagJoueur" v-if="partie" class="buttonState">
                             <s-button 
                                label="Afficher les incohérences"
                                :theme="showErrorsFlag ? 'is-danger is-normal' : 'is-primary is-normal'"
                                :icon="showErrorsFlag ? 'eye-slash' : 'eye'"
                                v-show="partie.error"
                                @onclick="openModalErrors()"
                                v-if="partie"
                            />&nbsp;
                           
                            <s-button  :role="role"  
                            v-show="partie.state=='WAITING' && indexPartie < parties.length" 
                            icon="play" label="Démarrer" theme="is-success is-normal" @onclick="setStatePartie"/>
                            <s-button  
                                :role="role"  v-show="partie.state=='INPROGRESS'  && indexPartie < parties.length" 
                                icon="pause" label="Mettre en pause" theme="is-primary is-normal" @onclick="setStatePartie"/>
                            
                            <s-button  
                                :role="role"   icon="unlock" 
                                label="Débloquer" theme="is-warning" 
                                @onclick="tournoi.cadrage=false"
                                v-show="parties.length==3 && tournoi.cadrage"
                                />
                            
                            <s-button  
                                :role="role"   icon="play" 
                                label="Continuer" theme="is-success" 
                                @onclick="modalOrganiserTournoi=true"
                                v-show="displayOrganiser"
                                />
                        </div>              
                        <div v-show="!changeFlagJoueur" v-if="partie" class="buttonPlayers">
                         &nbsp;
                        </div>
                    </div>
            </div>
            
            <div style="float:left;width: 450px">
                <span v-show="!changeFlagJoueur" v-if="partie">
                <div class="search" >
                    <s-button 
                        label="Paramètres"
                        theme="is-dark"
                        icon="cog"
                        :role="role"
                        @onclick="modalConfiguePartie=true"
                    />&nbsp;    
                   
                    <s-button icon="bed" theme="is-warning" 
                            :label="playersClock.length + ' joueurs en attente'" 
                            @onclick="modalPlayerClock=true"
                            :role="role" 
                            v-if="playersClock.length>0 && tournoi.options.competition!=3"
                        />
                    <s-you-tube id="video_deroulement" :club="club" theme="is-info" />
                
                </div>
                    <s-input-search theme="is-primary" v-model="search" themeEraser="is-warning"
                        placeholder="numéro ou nom"
                        width="300px" 
                        />
            </span>
            </div>
        <div class="titlePartie" v-if="partie">

            <b >{{titlePartie()}}</b>
            <div>
            
                <div class="state" v-show="partie.state=='WAITING'">
                     En attente
                </div>
                <div class="state" v-show="partie.state=='INPROGRESS'">
                    En cours 
                </div>
                <div class="state" v-show="partie.state=='FINISH'">
                    Terminé
                </div>
                <div class="howEquipes" v-if="equipes!=null">
                    {{nbParties}} / {{equipes.length}}
                </div>
                
            </div>
           
           
        </div>
      
           
        </div>
          <legend-block :options="tournoi.options"  v-show="showErrorsFlag"/>
        <div class="slideEquipe">
            
            <hooper style="height: 100%;" ref="slideEquipe" 
                 :settings="hooperSettings" :initialSlide="indexPartieParam"
                @slide="updateCarousel"  v-if="parties!=null && parties.length>0" >
                <slide v-for="(partie, indexItemPartie) in parties">
                    <div class="listEquipe" >
                        <equipe-all
                            :indexPartie = 'indexItemPartie'
                            :tournoi = "tournoi"
                            :search = "search"
                            :joueurs = "joueurs"
                            :club="club"
                            :role = "role"
                            :changeFlagJoueur = "changeFlagJoueur"
                            :showError = "showErrorsFlag"
                            :parties="parties"
                            :nav="nav"
                            @selectJoueur = "selectJoueur"
                            @changeEffect="changeEffect"
                            @openModalJoueur="openModalJoueur"
                            @modalErreurGG="openModalErrorGG"
                            @openModalScore="openModalScore"
                            @setOpenModalTerrain="setOpenModalTerrain"
                            @setTimer="setTimer"
                            v-if="tournoi.options.competition!=3"
                            :ref="'equipeALL'+indexItemPartie"

                            />
                        <equipe-all-championnat
                            :indexPartie = 'indexItemPartie'
                            :nbParties = 'parties.length'
                            :refresh='indexItemPartie==indexPartie'
                            :tournoi = "tournoi"
                            :search = "search"
                            :joueurs = "joueurs"
                            :club="club"
                            :role = "role"
                            :changeFlagJoueur = "changeFlagJoueur"
                            :showError = "showErrorsFlag"
                            @selectJoueur = "selectJoueur"
                            @changeEffect="changeEffect"
                             @openModalScore="openModalScore"
                            v-if="tournoi.options.competition==3"
                            @waiting="openModalWaiting=!openModalWaiting"
                            :ref="'equipeALL'+indexItemPartie"
                            />
                    </div>
                </slide>
                <slide v-if="tournoi.options.GG" >
                    
                    <div v-if="indexPartieParam>0">
                        <div v-if="TirageNextEnabled()">
                            <div class="notification is-warning" v-if="parties[indexPartieParam-1].state != 'FINISH'">
                                <s-l id="inprogress_explainGGNotDoneTirage">Il faut terminer la partie précedente afin de pouvoir effectuer le tirage de cette partie</s-l>
                            </div>
                            <div class="notification is-info" v-if="parties[indexPartieParam-1].state == 'FINISH'">
                                <s-l id="inprogress_explainGG">Tirage des gagnants contre les gagnants des précédentes parties.Le tirage sera effectué en prenant les gagnants et les perdants de la précedante partie</s-l>
                                <br/><s-button  :role="role"  
                                    icon="retweet" label="Effectuer le tirage" theme="is-success is-large" @onclick="addPartie"/>
                            </div>
                            <div class="notification is-warning" v-if="parties[indexPartieParam-1].state != 'FINISH'">
                                <s-l id="inprogress_explainGGNotDoneTirage">Il faut terminer la partie précedente afin de pouvoir effectuer le tirage de cette partie</s-l>
                            </div>
                        </div>
                        

                        <div v-if="TirageNextEnabled() && parties[indexPartieParam]">
                            <s-l id="inprogress_explainGGAllEquipePlay">Dans ce mode, le tirage s'effectue au fure et à mesure de l'avancée de la parties précedente. Revenez sur la partie précedente cliquez sur enregistrer sur une de vos parties.</s-l>
                        </div>
                    </div>
                </slide>
            </hooper> 
        </div>
        <div style="height:100px" class="g_mobileOn">
            &nbsp;
        </div>
        <modal-reinit
                :parties="parties"
                :tournoi="tournoi"
                :open="modalReinit"
                @close="modalReinit=false"
                @reinitialiser="reinitialiser"
                @setState="setState"
        />
        <modal-terrain
            :open="openModalTerrain"
            :club="club"
            :tournoi="tournoi"
            :equipes="equipes"
            :equipe="equipeSelectedByTerrain"
            :indexPartie="indexPartie"
            :role="role"
            :parties="parties"
            @close="openModalTerrain=false"
            @reinit="reinitStateTerrainsTournois"
            @setTerrainEquipe="setTerrainEquipe"
            v-if="equipeSelectedByTerrain!=null"
        />
        <modal-configure
            :open="modalConfiguePartie"
            :club="club"
            :indexPartie="indexPartie"
            :tournoi="tournoi"
            :equipes="equipes"
            :parties="parties"
            :partie="partie"
            :playersClock="playersClock"
            :pointMax="pointMax"
            :role="role"
            :firestore="$firestoreRefs"
            @setPointMax="setPointMax"
            @openPlayerClock="openPlayerClock"
            @reinitStateTerrainsTournois="reinitStateTerrainsTournois"
            @openModalReinit="openModalReinit"
            @modalJoueur="modalJoueur=true"
            @close="modalConfiguePartie=false"
            @changeIndexPartie="changeIndexPartie"
        />
        <s-modal
                title="Joueurs en attente d'équipe"
                :open="modalPlayerClock"
                :close="true"
                @close="modalPlayerClock=false">
                <div v-if="playersClock.length==0">
                    Aucun joueurs en attente
                </div>
                <div v-if="playersClock.length!=0">
                    Ces joueurs n'ont pas été tirés au sort et n'ont pas été intégrés dans une équipe<br/>
                    <b>Cliquez sur le joueur pour lui attribuer une équipe manuellement si vous le souhaitez ...</b>
                    <div v-for="player in playersClock" style="margin-bottom: 10px" >
                        <s-button :label="(player.numero+1) + ' ' + player.name" theme="is-info"
                        @onclick="selectJoueurClock(player.numero)" icon=""/>
                    </div>
                </div>
        </s-modal>
        <s-modal
                    title="Changer de partie"
                    :open="openChangeIndexPartie"
                    :close="true"
                    @close="openChangeIndexPartie=false">
                   
                    <div style="width:100%;text-align:center" v-if="parties">
                    <div v-for="i in parties.length" style="padding:10px">
                        <s-button :label="titlePartie(i)" 
                            :theme="(i-1 == parseInt(indexPartie)) ? 'is-normal is-success' : 'is-normal is-primary'" 
                            @onclick="changeIndexPartie(i-1)" 
                            :disabled="changeFlagJoueur" 
                            />&nbsp;
                    </div>
                     <div style="padding:10px" v-if="tournoi.options.competition != 3 && !tournoi.options.GG">
                        <s-button :role="role" icon="plus" theme="is-primary" label="Ajouter une partie" @onclick="addPartie(false)"/>
                    </div>
                    </div>
        </s-modal>
        <s-modal
                :open="openJoueurModify"
                :close="true"
                @close="openJoueurModify = false"
                :title="tournoi.options.mode == 'FORME' ? 'Modifier une équipe' : 'Modifier un joueur'"
            >
                <joueurModify 
                    :joueur="joueurSelected" 
                    :equipe="equipeSelected"
                    :joueurs="joueurs"  
                    :tournoi="tournoi"
                    :club="club"
                    v-if="joueurSelected"
                    :deleteJoueur="true"
                    :changerJoueurShow="true"
                    :affectMembre="true"
                    :parties="parties"
                    @renameEquipe="renameEquipe()"
                    @deleteJoueur="deleteJoueur()"
                    @changerJoueur="changerJoueur()"
                    @affectMembre="affectMembre()"
                    @abandonnePartie="abandonnePartie"
                    />
        </s-modal>
        <s-modal
                title="Organiser votre tournoi"
                :open="modalOrganiserTournoi"
                @close="modalOrganiserTournoi=false"
                :close="true"
                v-if="tournoi.options.competition==3"

        >
            <modal-cadrage 
                :tournoi="tournoi" 
                :club="club" 
                :equipes="equipes"
                :indexPartie="indexPartie"
                :open="modalOrganiserTournoi"
                @close="closeModalCadrage"
                @cancel="modalOrganiserTournoi=false"
            />
        </s-modal>
        
        <s-modal 
                :title="titleModalJoueur"
                :close="true"
                @close="modalJoueur=false"
                :open="modalJoueur && !this.tournoi.addJoueurInProgress"
        >
            <joueur-modal 
                :role="role" 
                :club="club" 
                :tournoi="tournoi" 
                :changeMembre="changeMembre"
                @changeMembre="saveChangeMembre"
                @refresh="refresh" 
                @close="modalJoueur=false"
                @addJoueurInTournoiInProgress="addJoueurInTournoiInProgress"
              
                :indexPartie="indexPartie"
                v-if="modalJoueur" />
        </s-modal>
        <s-info 
            id="exlainError"
            :open="errorDetail!=null"
            @close="errorDetail=null"
            title="incoherence"
            v-if="errorDetail!=null"
        >
           
            <div v-if="errorDetail!=null">
            <span v-show="errorDetail.type==1">
                Ce joueur  a déjà rencontré un des  joueurs 
            </span>
            <span v-show="errorDetail.type==2">
                Ce joueur  a déjà coéquipié avec un des joueurs 
            </span>
            <span v-show="errorDetail.type==3">
                Ce joueur  a déjà joué avec une triplette 
            </span>
            <span v-show="errorDetail.type==5">
                Ce joueur  a déjà joué contre une triplette 
            </span>
            <span v-show="errorDetail.type==4">
                Ce joueur a déjà rencontré un des joueurs (soit contre soit en tant que coéquipier)
            </span>
             <span v-show="errorDetail.type==6">
                Ce joueur a déjà joué un jeu blanc
            </span>
            </div>
        </s-info>
        <s-info
            id="explainAddJouerInProgress" 
            :open="modalExplainAddJouerInProgress"
            @close="modalExplainAddJouerInProgress=false"
            :big="true"
            title="Ajout d'un joueur"
        >Le joueur que vous venez d'ajouter a été ajouté dans une nouvelle équipe pour chaque partie <br/>
            Le système considère qu'il a perdu chaque partie.<br/>
            Vous pouvez l'affecter à une équipe existante ou le suppimer (en cliquant sur son numéro) <br/>
            Ou alors réinitialiser les parties que vous souhaitez en cliquant sur le bouton "Reinitialiser"
        </s-info>
          <s-info
                :open="changeModalErreurGG"
                :close="true"
                @close="changeModalErreurGG=false"
                title="Attention"
                :big="true"
                id="Alerte_GG_changeGagnant"
            >
            <div style="z-index:10">
                Vous avez changé le gagnant d'une partie... le tirage au sort de la partie suivant a donc été adapté !
            </div>
        </s-info>
        <s-info
                :open="modalErreurGG"
                :close="true"
                @close="modalErreurGG=false"
                title="Non sauvegardé"
                :big="true"
                 id="Alerte_GG_changeGagnantNotWork"
            >
            <div style="z-index:10">
                <b>Désolé... </b><br/>
                Vous avez tenté de modifier le gagnant d'un jeu alors que le tirage a été effectué et qu'il y a déjà un score pour un des joueurs dans la partie suivante. <br/>
                Pour régler le problème, supprimer les scores des joueurs de la partie suivante.
            </div>
        </s-info>
        <div v-show="changeFlagJoueur" class="changeFlagJoueur" >
            
            <div style="float:right">
                <s-button icon="ban"
                    theme="is-danger is-small"
                    label="Annuler le changement" @onclick="changeFlagJoueur=false"/>
            </div>
            <div v-if="joueurSelected" style="display:inline-block;">
                Changement d'équipe pour <b>{{joueurSelected.numero + 1}} {{joueurs[joueurSelected.numero].pseudo}}</b><br/>
                <br/>cliquez sur un des numeros pour échanger votre joueur<br/>
                <br/>
            </div>
        
        </div>
        <modal-score
            :open="modalScore"
            @close="modalScore=false"
            :equipe = "equipeSelected"
            :type="typeSelected"
            :pointMax="pointMax"
            @supprimerScore="supprimerScore"
            @saveScore="saveScore"
            @changeType="typeSelected=='joueurs' ? typeSelected='contre' : typeSelected='joueurs'"
        />
        <modal-config-one-timer
            :open="openModalConfigOneTimer"
            :equipe="equipeSelected"
            :firestore="$firestoreRefs"
            :tournoi="tournoi"
            @close="openModalConfigOneTimer=false"
            @stopTimer="stopTimer"
        />
        </div>
</template>
<style scoped>
    .hooper  {
        margin-top: 10px;
    }
    .state {
        font-weight: bolder;
        font-size: 22px;
        display:inline-block;
    }
    .howEquipes {
        font-size: 18px;
        font-weight: bolder;
        color: black;
       display:inline-block;
        width: 70px;
        margin-left: auto;
        margin-right: auto;
    }
    .titlePartie {
        position: relative; 
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        text-align: center;
        width: 420px;
        font-size: 22px;
        padding-top: 5px;
        color: black;
       
        height: 100px;
    }
   
    
    @media screen and (min-width: 420px) {
        
        .topFixed {
            height: 117px;
            padding-right: 20px;
            padding-left: 20px;
            top: 30px;
            width: 100%;
            z-index: 2;
            position: fixed;
            padding-top: 20px;
             background-color:  var(--backgound-color);
             box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -webkit-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
            -moz-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
        }
        .slideEquipe {
            padding-top: 140px;
            z-index: 500;

        }
    
    }
    @media screen and (max-width: 420px) {
        .topFixed {
            display:none;
        }
        
        .slideEquipe {
            padding-top: 65px;
            z-index: 500;
            margin-left: 10px;
            margin-right: 10px;
            
        }
        
    }
    
    .buttonState {
        padding-top: 5px;
       
    }
    .buttonPlayers {
        padding-top: 5px;
        
        float: left;
    }
    .changeFlagJoueur {
        position: fixed;
        top:55px;
        height: 100px;
        width: 100%;
        left: 0px;
        z-index: 1000;
        background-color: rgba(247, 209, 138, 0.973);
        color: black;
        padding: 10px;
    }
    
    .reinit {
        float: right;
    }
    .addJoueur {
        padding-left: 10px;
        display: inline-block;
        padding-top: 5px;
    }
    .buttonParties {
       
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .header {
        padding-top: 5px;
        font-size: 14px;
        font-weight: bold;
        color:rgb(141, 87, 17)
    }
    
    .waiting {
        color: rgb(35, 90, 161);
        padding-left: 5px;
    }
    .search {
        padding-top: 10px;
        padding-bottom: 2px;
    }
    .listEquipe {
        margin-top: 10px;
        width: 100%;
        text-align: center;
        border: none;
        
    }
    
   
    
</style>
<script>
import JoueurModal from "@/views/joueurs/list.vue"
import equipeAll from "@/views/tournoi/inProgress/equipeAll.vue"
import equipeAllChampionnat from "@/views/tournoi/inProgress/equipeAllChampionnat.vue"
import modalCadrage from "@/views/tournoi/championnat/modalCadrage.vue"
import tournoi_fct from '@/firebase/tournoi'
import Equipe_object from '@/firebase/tirage2/Equipe'
import firebase_api from '@/firebase/firebase_api'
import { Hooper, Slide} from 'hooper';
import joueurModify from '@/views/tournoi/inProgress/joueurModify'
import firebase from "firebase"
import navbarTournoi from "@/views/tournoi/navbar.vue"
import navbarFooterTournoi from "@/views/tournoi/navbarfooter.vue"
import VueHtml2pdf from 'vue-html2pdf';
import pdfPartie from '@/views/tournoi/export/pdfpartie.vue'
import legendBlock from '@/views/tournoi/legend.vue'
import modalReinit from '@/views/tournoi/inProgress/modals/modalReinit.vue'
import modalTerrain         from '@/views/tournoi/inProgress/modals/modalTerrain.vue'
import modalConfigure  from '@/views/tournoi/inProgress/modals/modalConfigurePartie.vue'
import modalConfigOneTimer  from '@/views/tournoi/inProgress/modals/modalConfigOneTimer.vue'
import modalScore from '@/views/tournoi/inProgress/modals/modalScore.vue'
import terrain_object from '@/firebase/terrain.js'

import 'hooper/dist/hooper.css';
import ButtonTerrain from './inProgress/buttonTerrain.vue'
export default {
    props: ["club", "tournoi", "joueurs","role", "indexPartieParam", "nav"],
    components: {
        equipeAll,
        navbarTournoi,
        JoueurModal,
        Hooper,
        Slide,
        joueurModify,
        navbarFooterTournoi,
        equipeAllChampionnat,
        modalCadrage,
        VueHtml2pdf,
        pdfPartie,
        legendBlock,
        modalReinit,
        ButtonTerrain,
        modalTerrain,
        modalScore,
        modalConfigure,
        modalConfigOneTimer
    },
   
    computed: {
        hasTerrain: {
            get() {
            var bool = false;
                if (typeof(this.tournoi.options.zones)!="undefined")
                    if (Object.keys(this.tournoi.options.zones).length!=0)
                        bool = true;
            return bool;
            }
        },
        zones: {
            get() {
                return this.tournoi.options.zones;
            }
        },
         inJoueurInTournoi: {
            get() {
                var joueurs = this.tournoi.joueurs;
                
                var idClub = this.$store.getters.getUser.clubs.findIndex(club=>club.idClub == this.club.id);
                if (idClub != -1) {
                    var idJoueur = this.$store.getters.getUser.clubs[idClub].idJoueur;
                    var findJoueur = joueurs.findIndex(joueur=>joueur.id == idJoueur);
                    if (findJoueur != -1)
                        return 1
                    else
                        return 0;
                }
                else
                    return null;
                
            }
        },
       
        pointMax: {
            get() {
                if (this.partie!=null)
                    if (typeof(this.partie.maxPoint)=="undefined")
                        return 13;
                    else
                        return this.partie.maxPoint
                else
                    return 13;
            },
            set(val) {
                this.partie.maxPoint = parseInt(val);
            }
        },
        nbParties: {
            get() {
                var nb=0;
                if (this.equipes != null) {
                    this.equipes.forEach(equipe=>{
                        nb = equipe.state == "FINISH" ? nb+1 : nb;
                    })
                }
                return nb;
            }
            
        },
        openModal: {
            get() {
                return this.openChangeIndexPartie || this.openJoueurModify || this.modalJoueur || this.modalOrganiserTournoi;
            }
        },
        
        showHeader: {
            get() {
               
                return !this.menuBurger && !this.openJoueurModify && !this.modalReinit && !this.modalJoueur
            }
        },
        displayOrganiser: {
            get() {
                
                if (this.tournoi.options.competition==3) {
                   if (this.indexPartie>1) {
                    
                        if (this.partie.state=="FINISH") {
                             
                            if (this.indexPartie==(this.parties.length-1)) {
                               
                                return !this.tournoi.cadrage;
                            }
                                
                            else
                                return false;
                        }
                        else
                            return false; // on test
                   }
                   else
                        return false;
               }
               else 
                return false;
            }
        },
        partieState: {
            get() {
                if (this.partie != null && typeof(this.partie)!="undefined")
                    return this.partie.state;
                else
                    return null;
            }
        }  
    },
    data() {
        return {
            equipeSelectedByTerrain: null,
            openModalTerrain: false,
            openModalConfigOneTimer:false,
            modalScore: false,
            playersClock: [],
            modalPlayerClock: false,
            hooperSettings: {
                    infiniteScroll: false,
                    centerMode: true,
                    mouseDrag:false,
                    wheelControl:false,
                    touchDrag:true
            },
            changeModalErreurGG: false,
            modalErreurGG: false,
            errorDetail: null,
            modalConfiguePartie: false,
            modalDeletePartie: false,
            modalReinit: false,
            equipesPagination:[],
            options: {
                marge: 0,
                filename: 'partie',
                html2canvas: {
                    scale: window.devicePixelRatio,
                    useCORS: true,
                    proxy: 'https://firebasestorage.googleapis.com'
                },
                jsPDF: {
                    unit: 'in',
                    format: 'a4',
                    orientation: 'landscape'
                }
            },
            openChangeIndexPartie: false,
            indexPartie : 0,
            menuBurger: false,
            search: "",
            modalJoueur: false,
            modalReinit: false,
            changeFlagJoueur: false,
            joueurSelected: null,
            equipeSelected: null,
            typeSelected: null,
            equipes: null,
            partie: null,
            parties: null,
            showErrorsFlag: false,
            
            openJoueurModify: false,
            
            titleModalJoueur: 'Ajouter un joueur',
            changeMembre: null,
            modalOrganiserTournoi: false,
            openModalWaiting: false,
            searchByMobile: false,
            modalExplainAddJouerInProgress: false
        }
    },
    
    watch: {
        
        indexPartie: {
            handler(indexPartie) {
                window.scrollTo(0,0);
                
                this.$emit("changeIndexPartie", indexPartie);
                if (indexPartie < this.parties.length) {
                    this.refreshBind(false);
                    if (this.$store.getters.getDemo.active) {
                        var concoursJson = {
                            idClub: this.club.id,
                            idTournoi: this.tournoi.id,
                            idPartie: indexPartie
                        }
                        this.$store.dispatch("setTutoSaveConcours", concoursJson)
                    }
                    
                }
                if (this.$store.getters.getDemo.active) {
                        var concoursJson = {
                            idClub: this.club.id,
                            idTournoi: this.tournoi.id,
                            idPartie: indexPartie
                        }
                        this.$store.dispatch("setTutoSaveConcours", concoursJson)
                    }
                    
            }
        }
        
    },
    mounted() {
        
        this.changeIndexPartie(this.indexPartieParam);
        this.refreshBind(true);
        if (this.$store.getters.getDemo.active) {
            var concoursJson = {
                idClub: this.club.id,
                idTournoi: this.tournoi.id,
                idPartie: 0
            }
            this.$store.dispatch("setTutoSaveConcours", concoursJson)
        }
        
    },
        
      methods: {

            // *******************************
            // Coeur du métier 
            // *******************************
            refreshBind(all) {
                if (all) {
                    this.$bind("parties", firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                        .collection("parties"))
                        .then(()=>{
                        
                        })
                        .catch(err => {
                            console.log("binding Parties")
                        })
                }
                this.$bind("equipes", firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                            .collection("parties").doc("P"+this.indexPartie).collection("equipes"))
                            .then(()=>{
                               
                                this.initPagination();
                                this.initPlayersClock();
                                this.reinitStateTerrainsTournois ();
                            })
                            .catch(err => {
                                console.log("binding equipes")
                            })
                this.$bind("partie", firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id)
                            .collection("parties").doc("P"+this.indexPartie)).then(()=>{
                                
                            })
                            .catch(err => {
                                console.log("binding partie")
                            })
            },
            initPagination() {
                this.equipesPagination=[];
                var indexPagination = 0;
                var compteur=0;

                var maxLigne = 10;
                var equipesOrder = JSON.parse(JSON.stringify(this.equipes));
                if (this.hasTerrain) {
                    equipesOrder.sort((a,b)=> {
                        if (typeof(a.terrain)!="undefined" && typeof(b.terrain)!="undefined") {
                            if (b.terrain==null && a.terrain==null)
                                return 50;
                            else if (b.terrain==null)
                                return -1;
                            else if (a.terrain==null)
                                return 100;
                            else
                                return a.terrain.numero - b.terrain.numero;
                        }
                        else
                            return 100;
                    })
                }
                if (this.tournoi.options.competition==3) {
                    maxLigne = 7;
                    equipesOrder.forEach((equipeItem, indexEquipe)=>{
                        if (equipeItem.pool == null)
                            var numeroPoule = 0;
                        else
                            var numeroPoule = equipeItem.pool;
                        if (compteur<maxLigne) {
                            if (typeof(this.equipesPagination[indexPagination]) == "undefined") {
                                this.equipesPagination[indexPagination] = {};
                                this.equipesPagination[indexPagination].poules=[];
                            }
                            if (typeof(this.equipesPagination[indexPagination].poules[numeroPoule])=="undefined") {
                                this.equipesPagination[indexPagination].poules[numeroPoule]=[];
                                this.equipesPagination[indexPagination].display = equipeItem.pool != null;
                            }
                            this.equipesPagination[indexPagination].poules[numeroPoule].push(equipeItem);
                            compteur++;
                        }
                        else {
                            if (typeof(this.equipesPagination[indexPagination].poules[numeroPoule])=="undefined") {
                                this.equipesPagination[indexPagination].poules[numeroPoule]=[];
                                this.equipesPagination[indexPagination].display = equipeItem.pool != null;
                            }
                            this.equipesPagination[indexPagination].poules[numeroPoule].push(equipeItem);
                            indexPagination++;
                            compteur=0;
                        }
                    });
                }
                else {
                    equipesOrder.forEach((equipeItem, indexEquipe)=>{
                    if (compteur<maxLigne) {
                        if (typeof(this.equipesPagination[indexPagination]) == "undefined") {
                            this.equipesPagination[indexPagination] = {};
                            this.equipesPagination[indexPagination].poules = [];
                            this.equipesPagination[indexPagination].display = false;
                            this.equipesPagination[indexPagination].poules[0] = [];
                        }
                        this.equipesPagination[indexPagination].poules[0].push(equipeItem);
                        compteur++;
                    }
                    else {
                        
                        this.equipesPagination[indexPagination].poules[0].push(equipeItem);
                        indexPagination++;
                        compteur=0;
                    }
                    });
                }
                
          },
            // ***********************************
            // Gestion des terrains
            // ***********************************
            reinitStateTerrainsTournois() {
                terrain_object.object.reinitStateTerrainsTournois (
                                this.zones, 
                                this.indexPartie, 
                                this.club, 
                                this.tournoi, 
                                this.equipes);
                
            },
            setTerrainEquipe(equipe, terrainEquipe) {
                this.$firestoreRefs.equipes.doc(equipe.id).update({
                        terrain: terrainEquipe
                }).then(equipe=>{
                        this.openModalTerrain=false;
                        this.reinitStateTerrainsTournois();
                })
            },
            setOpenModalTerrain(equipe) {
                this.equipeSelectedByTerrain = equipe;
                this.openModalTerrain= true;
            },
            // ****************************
            // Gestion affichage changement des tirages
            // ******************************
            titlePartie(indexParam) {
                if (typeof(this.parties) != "undefined") {
                    if (typeof(indexParam)=="undefined")
                    var index = parseInt(this.indexPartie) +  1;
                        else
                    var index = indexParam;
                    if (this.tournoi.options.competition==3) {
                        
                        if (typeof(this.parties[index-1])!="undefined") {
                            
                            
                            if (this.parties[index-1].type=="TOUR1")
                                return "TOUR 1"
                            if (this.parties[index-1].type=="TOUR2")
                                return "TOUR 2"
                            if (this.parties[index-1].type=="TOUR3")
                                return "TOUR 3"
                            if (this.parties[index-1].type=="BARRAGE")
                                return "BARRAGE"
                            if (this.parties[index-1].type=="CADRAGE")
                                return "CADRAGE"
                            if (this.parties[index-1].type=="ELIMINATOIRE") {
                                if (typeof(this.parties[index-1].name) != "undefined" )
                                    return this.parties[index-1].name;
                                else
                                    return "ELIMINATOIRE";
                            }
                        }
                    }
                    else
                        return "PARTIE " + index ;
                }
          
            
             },
            TirageNextEnabled() {
                var bool = false; 
                if (typeof(this.tournoi.options.choiceWaitingPartie)!="undefined")
                    bool = this.tournoi.options.choiceWaitingPartie;
                return bool;
            },
            disabledPartieNext(indexPartie) {
              if (typeof(this.parties)=="undefined")
                return true;
              else if (this.tournoi.options.competition==3) {
                 return this.indexPartie== this.parties.length-1;
              }
              else if (this.tournoi.options.GG) {
                  if (typeof(this.parties[indexPartie]) == "undefined")
                    return true;
                  else if (this.parties[indexPartie].state=="FINISH") {
                    return false;
                  }
                  else {
                      return this.indexPartie== this.parties.length-1;
                  }
              }
              else
                return this.indexPartie== this.parties.length-1;
          },
          setNav(nav) {
            this.$emit("nav",nav)
          },
            // ****************************
            // Gestion des scores
            // ******************************
            
            supprimerScore() {
                this.$refs['equipeALL'+this.indexPartie][0].eraserScore(this.equipeSelected);
                this.modalScore = false;
                terrain_object.object.reinintStateTerrain(this.zones, this.club, this.tournoi, this.indexPartie, this.equipeSelected, true);
            },
            openModalScore(equipe, type) {
                this.equipeSelected = equipe;
                this.modalScore = true;
                this.typeSelected = type;
            },
            saveScore(score, scoreMax) {
                    var typeVS = this.typeSelected == "contre" ? "joueurs" : "contre";
                    this.equipeSelected.score[this.typeSelected] = parseInt(score);
                    if (!isNaN(score) && scoreMax) {
                        this.equipeSelected.score[typeVS] = this.pointMax;
                    }
                    
                    this.$refs['equipeALL'+this.indexPartie][0].saveScore(this.equipeSelected);
                    this.modalScore = false;
                    terrain_object.object.reinintStateTerrain(this.zones, this.club, this.tournoi, this.indexPartie, this.equipeSelected, true);
            },
            setPointMax(pointMax) {
                this.pointMax = pointMax;
            },
             // ****************************
            // Gestion des joueurs en attente
            // ******************************
            selectJoueurClock(joueurNumero) {
                var joueurSelected = {
                    numero: joueurNumero
                }
                this.modalPlayerClock = false;
                this.selectJoueur(joueurSelected, null);
            },
            openPlayerClock() {
                this.playersClock = [];
                var playerCurrent = [];
                var player = {};
                this.equipes.forEach(equipe=>{
                    var reinit = false;
                    if (equipe.exists != null && !equipe.exists) {
                            reinit = true;
                            equipe.exists = true;
                    }
                    for (var joueur in equipe.joueurs) {
                        if (reinit) {
                            equipe.joueurs[joueur] = null;
                        }
                        else if (equipe.joueurs[joueur] != null) {
                            playerCurrent.push(equipe.joueurs[joueur].numero);
                        }
                    }
                    for (var joueur in equipe.contre) {
                        if (reinit) {
                            equipe.joueurs[joueur] = null;
                        }
                        else if (equipe.contre[joueur] != null) {
                            playerCurrent.push(equipe.contre[joueur].numero);
                        }
                    }
                    if (reinit) {
                            this.$firestoreRefs.equipes.doc(equipe.id).set(
                                equipe
                            );
                    }
                })
                
                this.joueurs.forEach((joueur, indiceJoueur)=>{
                    if (playerCurrent.indexOf(indiceJoueur)==-1) {
                            player.numero = indiceJoueur;
                            player.name = this.tournoi.joueurs[player.numero].pseudo == '' ? "invité" : this.tournoi.joueurs[player.numero].pseudo;
                            this.playersClock.push(JSON.parse(JSON.stringify(player)));
                    }
                })
                this.modalConfiguePartie = false;
                this.modalPlayerClock = true;
            },
            initPlayersClock() {
                this.playersClock = [];
                var player= {};
                
                var displayButton = this.indexPartie == 0;
                if (!displayButton) 
                    displayButton = this.parties[this.indexPartie-1].state == 'FINISH';
            
                if (displayButton) {
                    
                    var playersPlayInPartie = [];
                    this.equipes.forEach(equipe=>{
                        for (var joueur in equipe.joueurs) {
                            if (equipe.joueurs[joueur] != null) {
                            playersPlayInPartie.push(equipe.joueurs[joueur].numero);
                        }
                        }
                        for (var contre in equipe.contre) {
                            if (equipe.contre[contre] != null) {
                            playersPlayInPartie.push(equipe.contre[contre].numero);
                        }
                        }

                    })
                    this.joueurs.forEach((joueur, indiceJoueur)=>{
                        if (playersPlayInPartie.indexOf(indiceJoueur)==-1) {
                                player.numero = indiceJoueur;
                                player.name = this.tournoi.joueurs[player.numero].pseudo == '' ? "invité" : this.tournoi.joueurs[player.numero].pseudo;
                                this.playersClock.push(JSON.parse(JSON.stringify(player)));
                        }
                    })
                
                }
            },
            
          // ***********************
          // Gestion du gagnant gagnant
          // ************************
          openModalErrorGG(flag) {
            
            if (!flag)
                this.modalErreurGG=true;
             else
                this.changeModalErreurGG=true;
          },
          openModalReinit() {
                this.modalConfiguePartie = false;
                this.modalReinit=true
          },
          
          
          openModalJoueur(errorDetail) {
              
              this.errorDetail = errorDetail;
              
          },
            addJoueurInTournoiInProgress(joueurTournoi) {
                    if (this.tournoi.demo) {
                        this.tournoi.addJoueurInProgress=true;
                        tournoi_fct.object.set(this.club, this.tournoi,()=>{});
                    }
                    this.modalJoueur=false;
                    this.modalConfiguePartie = false;
                    joueurTournoi.numero = this.tournoi.joueurs.length;
                    tournoi_fct.object.addJoueur(this.club, this.tournoi, joueurTournoi, ()=>{
                         this.modalExplainAddJouerInProgress = true;
                    });
                    //**** Je le met dans une équipe vierge */
                    var equipe = new Equipe_object();
                    var idEquipe = "E" + this.equipes.length;
                    var jsonEquipe =  equipe.json;
                    
                    jsonEquipe.joueurs.J1 = {
                        numero: joueurTournoi.numero,
                        error: false,
                        errorDetail: {}
                    }
                    jsonEquipe.state="FINISH"
                    if (typeof(this.partie.maxPoint)!="undefined")
                        jsonEquipe.score.contre = this.partie.maxPoint;
                    else
                        jsonEquipe.score.contre = 13;
                    jsonEquipe.score.joueurs = 7;
                    // On ajoute du coup la nouvelle équipe partout 
                    for (var indexPartie in this.parties) {
                        var idPartie = this.parties[indexPartie].id;
                        firebase_api.api.getDb().collection("club").doc(this.club.id)
                            .collection("tournois").doc(this.tournoi.id)
                            .collection("parties").doc(idPartie)
                            .collection("equipes").doc(idEquipe).set(
                                jsonEquipe
                            );
                    }
           },
           goMonTournoi() {
             this.$router.push({name: "myTournoi", params:{idClub: this.club.id, idTournoi:this.tournoi.id}}).catch(error=>{});
          },
         
          
          generateReport () {
            this.initPagination();
            this.$refs.html2PdfPartie.generatePdf();
          },
          closeModalCadrage() {
                
                this.modalOrganiserTournoi = false;  
               
                var indexPartie = parseInt(this.indexPartie) + 1;
               
                this.changeIndexPartie(indexPartie);
          },
          
          affectMembre() {
              var numero = parseInt(this.joueurSelected.numero);
              numero++;
                if (this.joueurs[this.joueurSelected.numero].pseudo == '')
                    this.titleModalJoueur = "Affecter un membre au numero "+ numero ;
                else
                    this.titleModalJoueur = "Changer le membre du numero "+numero;
                this.changeMembre=this.joueurSelected.numero;
                this.modalJoueur = true;
          },
          renameEquipe() {
            
            tournoi_fct.object.set(this.club, this.tournoi, ()=>{
                   
              });
          },
          saveChangeMembre(joueurTournoi) {
            
              this.tournoi.joueurs[this.changeMembre] = joueurTournoi;
              tournoi_fct.object.set(this.club, this.tournoi, ()=>{
                   this.changeMembre=null;
                   this.modalJoueur = false;
                   this.$emit("refresh");
              });
          },
          openModalErrors() {
            if (this.showErrorsFlag)
                this.showErrorsFlag = false;
            else
                this.showErrorsFlag = true;
          },
          setState(state) {
              this.equipes = null;
              this.$emit("setState","INSCRIPTION");
          },
          selectJoueur(joueur, equipeSelected) {
              this.joueurSelected = joueur;
              this.equipeSelected = equipeSelected;
              this.openJoueurModify = true;
          },
          deleteJoueur() {
             var findOrigine = this.findEquipe(this.joueurSelected , this.equipeSelected);
             
             if (this.tournoi.options.mode == 'FORME') {
                for (var key in this.equipeSelected[findOrigine.vs]) {
                    this.equipeSelected[findOrigine.vs][key] = null;
                    
                }
             }
             else {
                    this.equipeSelected[findOrigine.vs][findOrigine.idJoueur] = null;
             }
            this.$firestoreRefs.equipes.doc( this.equipeSelected.id).set(
                this.equipeSelected
            ).then(()=>{
                this.openJoueurModify = false;
                this.initPlayersClock();
            })
        
            /* tournoi_fct.object.saveTournoi (this.club, this.tournoi, ()=>{
                 this.openJoueurModify = false;
            })*/
        },
       
        abandonnePartie( joueur, indexPartie, abandonne, updateTournoi)   {
            var numero = joueur.numero;
            var tournoiDoc = firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id);
            
            var partiesDocs = tournoiDoc.collection("parties").doc("P"+indexPartie)
            var equipesDocs = partiesDocs.collection("equipes")
            if (typeof(updateTournoi)=="undefined") {
                var abandonJoueurs = {};
                if (typeof(this.tournoi.options.abandonJoueurs)!="undefined")
                    abandonJoueurs = this.tournoi.options.abandonJoueurs;
                if (abandonne)
                    abandonJoueurs[joueur.numero] = indexPartie;
                else
                    delete abandonJoueurs[joueur.numero]
                this.tournoi.options.abandonJoueurs = abandonJoueurs;
                
                tournoiDoc.set({
                    options: this.tournoi.options
                }, {merge: true})
               
            }
            if (indexPartie<this.parties.length && abandonne) {
              
                equipesDocs.get().then(equipeData=>{
                    
                    var find = false;
                    var joueursInEquipeForme = [];
                    var equipesData = equipeData.docs;
                    equipesData.forEach((equipeDoc, indexEquipe)=>{
                        var equipe = equipeDoc.data();
                        for (var joueurItem in equipe.joueurs) {
                            if (equipe.joueurs[joueurItem]!=null)
                                    if (equipe.joueurs[joueurItem].numero == numero) {
                                        find = true;
                                        if (this.tournoi.options.mode == "FORME") {
                                            joueursInEquipeForme = JSON.parse(JSON.stringify(equipe.joueurs));
                                            for (var key in equipe.joueurs) {
                                                equipe.joueurs[key] = null;        
                                            }
                                        }
                                        equipe.joueurs[joueurItem] = null;
                                    }
                        }
                            
                        for (var joueurItem in equipe.contre) {
                            if (equipe.contre[joueurItem]!=null)
                                if (equipe.contre[joueurItem].numero == numero) {
                                    find = true;
                                    if (this.tournoi.options.mode == "FORME") {
                                            joueursInEquipeForme = JSON.parse(JSON.stringify(equipe.contre));
                                            for (var key in equipe.contre) {
                                                equipe.contre[key] = null;        
                                            }
                                    }
                                    equipe.contre[joueurItem] = null;
                                }
                        }
                        if (find) {
                            equipesDocs.doc(equipeDoc.id).update(equipe);
                        }
                        if (indexEquipe==equipesData.length-1) {
                            var equipenew = new Equipe_object();
                            var idEquipe = "E" + equipesData.length;
                            if (this.tournoi.options.mode == "FORME") {
                                equipenew.json.joueurs = joueursInEquipeForme;    
                            }
                            else {
                                equipenew.json.joueurs.J1 = JSON.parse(JSON.stringify(joueur));
                            }
                            equipenew.json.score["joueurs"] = 7;
                            equipenew.json.score["contre"] = 13;
                            equipenew.json.state='FINISH';
                           
                            equipesDocs.doc(idEquipe).set(equipenew.json);
                            this.abandonnePartie( joueur, indexPartie+1, abandonne, false);
                        }

                     })
                })
                
            }
            
              //this.$emit("close");
        },
          changerJoueur() {
               
                /*this.joueurSelected = joueur;
                this.equipeSelected = equipe;*/
                this.openJoueurModify = false;
                
                this.changeFlagJoueur = true;
               
            },
           changeEffect(joueur, equipe) {
            // lorsqu'on est en forme c'est toute l'équipe doit être changé !
            var findOrigine = this.findEquipe(this.joueurSelected, this.equipeSelected);
           
            if (joueur.numero != null)  {
                var findCible = this.findEquipe(joueur, equipe);
            }
            else {
                var findCible = {
                    idJoueur : joueur.idJoueur,
                    vs: joueur.vs
                }
            }
          
            var joueurTempo =  JSON.parse(JSON.stringify(this.joueurSelected));

            

            equipe[findCible.vs][findCible.idJoueur] = joueurTempo;
            if (this.tournoi.options.mode=='FORME') {
                var J2 = equipe[findCible.vs]["J2"];
                var J3 = equipe[findCible.vs]["J3"];
                equipe[findCible.vs]["J2"] = this.equipeSelected[findOrigine.vs]["J2"];
                equipe[findCible.vs]["J3"] = this.equipeSelected[findOrigine.vs]["J3"];
            }
            
            
            this.$firestoreRefs.equipes.doc(equipe.id).set(
                equipe
            ).then(()=>{
                    this.initPlayersClock();
            })

            if (joueur.numero == null)
                joueur = null;
            if (this.equipeSelected!=null) {
                this.equipeSelected[findOrigine.vs][findOrigine.idJoueur] = JSON.parse(JSON.stringify(joueur));
                if (this.tournoi.options.mode=='FORME') {
                    this.equipeSelected[findOrigine.vs]["J2"] = J2;
                    this.equipeSelected[findOrigine.vs]["J3"] = J3;
                }
            

                this.$firestoreRefs.equipes.doc(this.equipeSelected.id).set(
                    this.equipeSelected
                ).then(()=>{
                    this.initPlayersClock();
                })
            }
            this.openJoueurModify = false;
            this.changeFlagJoueur = false;
            
            
        },
         findEquipe(joueur, equipe) {
            var joueurFind= {
                vs: null,
                idJoueur: null
            };
            for (var vs in equipe) {
                 if (vs!="score" && vs!="cloture" && vs!="state") {
                        for (var idJoueur in equipe[vs]) {
                            if (equipe[vs][idJoueur] != null)
                                if (equipe[vs][idJoueur].numero == joueur.numero) {
                                    joueurFind.vs = vs;
                                    joueurFind.idJoueur = idJoueur;
                                }
                                    
                        }
                 }
            }
            return joueurFind;
        },
        updateCarousel(payload) {
          
            if (this.changeFlagJoueur)
                this.$refs.slideEquipe.slideTo(this.indexPartie);
            else {
               
                    this.indexPartie = payload.currentSlide;
                
            }
        },
        emitChangeFlag(flag) {
            this.changeFlagJoueur = flag;
        },
        
        changeIndexPartie(index) {
            this.openChangeIndexPartie = false;
            this.indexPartie = index;
            if (typeof(this.$refs.slideEquipe)!="undefined") {
                
                this.$refs.slideEquipe.slideTo(this.indexPartie);
            }
            
            //this.changeFlagJoueur = false;
        },
        
        reinitOnePartie(tournoiDoc, reinitParties, indexPartie, startIndexPartie) {
         
            var  partie = reinitParties[indexPartie];
            partie.id = this.parties[indexPartie].id;
            partie.equipes = [];
            tournoiDoc.collection("parties").doc(partie.id).collection("equipes").get().then(tournoiDb=>{
                for (var indiceEquipe in tournoiDb.docs) {
                    var doc = tournoiDb.docs[indiceEquipe];
                    var docData = doc.data();
                    delete docData[".key"]
                    partie.equipes.push(docData);
                   
                    if (indiceEquipe == tournoiDb.docs.length-1) {
                        if (indexPartie == reinitParties.length-1) {
                           
                            tournoi_fct.object.reinitTournoi(this.club, this.tournoi, reinitParties, startIndexPartie, parties=>{
                                this.openModalWaiting = false;      
                            })
                        }
                        else {
                            this.reinitOnePartie(tournoiDoc, reinitParties, indexPartie+1, startIndexPartie);
                        }
                    }
                }
            })
        },
        async reinitialiser(startIndexPartie) {
           
            // il faut reconstruire les parties avec les équipes et rejouer le tout
           this.openModalWaiting = true;
           this.modalReinit = false;  
            var reinitParties = JSON.parse(JSON.stringify(this.parties));
            
            var tournoiDoc = firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id);
            this.reinitOnePartie(tournoiDoc, reinitParties, 0, startIndexPartie);
            
        },
        refresh(tournoi) {
            this.tournoi.parties = tournoi.parties;
            
        },
        addPartie(gg) {
            if (typeof(gg)=="undefined")
                gg = true;
            var reinitParties = JSON.parse(JSON.stringify(this.parties));
           
            var tournoiDoc = firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id);
            var nbPartieTraite = -1;
            reinitParties.forEach((partie, indexPartie)=>{
                    partie.id = this.parties[indexPartie].id;
                    tournoiDoc.collection("parties").doc(partie.id).collection("equipes").get().then(snapshot=>{
                        nbPartieTraite++;
                        partie.equipes = [];
                        snapshot.docs.forEach((doc, indiceEquipe)=>{
                            var docData = doc.data();
                            delete docData[".key"]
                            partie.equipes.push(docData);
                            
                        })
                      
                        if (nbPartieTraite == reinitParties.length-1) {
                            tournoi_fct.object.addPartie(this.club, this.tournoi, reinitParties, gg, ()=>{
                                this.refreshBind();
                            })
                        }
                    })
                })
            
            
        },
        setStatePartie() {
            
            if (this.partie.state == 'WAITING') { 
                this.$firestoreRefs.partie.update({
                    state: "INPROGRESS"
                }).then( partie=>{
                    
                })
                this.setTimerEquipe(true);
            }
            else if (this.partie.state == 'INPROGRESS') {
                this.$firestoreRefs.partie.update({
                     state: "WAITING"
                })
                this.setTimerEquipe(false);
             }
        },
        
        back() {
            this.$emit("close");
        },
        setTimer(equipe) {
            
            this.openModalConfigOneTimer=true;
            this.equipeSelected = equipe;
        },
        stopTimer(id) {
          
            
            this.$refs['equipeALL'+this.indexPartie][0].stopTimer(id);
        },
        hasTerrainInEquipe(equipe) {
            var bool = true;
            if (this.hasTerrain) {
                if (typeof(equipe.terrain)!="undefined")
                    bool = equipe.terrain != null;
                else
                    bool = false;
            }
            return bool;
        },
        setTimerEquipe(bool) {
            
            if (typeof(this.tournoi.timer)!="undefined")
                if (this.tournoi.timer.active) {
                    const functions = firebase.app().functions('europe-west1');
                    functions.httpsCallable("stamp")().then(res=>{
                        this.equipes.forEach(equipe=>{
                            var state = bool ? "play" : "pause";
                            
                            if (typeof(equipe.timer)=="undefined") {
                                if (this.hasTerrainInEquipe(equipe)) {
                                    this.$firestoreRefs.equipes.doc(equipe.id).update({
                                        timer: {
                                            state: state,
                                            ts: res.data.timeStamp,
                                            delay : this.tournoi.timer.delay
                                        }
                                    })
                                }
                            }
                            else if (state == "play") {
                                 if (this.hasTerrainInEquipe(equipe)) {
                                    this.$firestoreRefs.equipes.doc(equipe.id).update({
                                        "timer.state": state,
                                        "timer.ts":res.data.timeStamp
                                    })
                                 }
                            }
                            else {
                              this.stopTimer(null);
                            }
                            
                        })
                    })
                    
                   
                }
        }
        
        }
        
    
}
</script>